<template>
  <div data-component-group="filter-forms" data-component="monthly">
    <FiltersForm
      :has-filters="hasFilters"
      :is-skeleton-loading="isSkeletonLoading"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        :label="$t('search')"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="issueDate"
        placeholder="Issue date"
        :config="dateConfig"
        :on-change="onChangeIssueDate"
      />

      <base-date-picker
        :date="invoicePeriod"
        placeholder="Invoice period"
        :config="dateConfig"
        :on-change="onChangeInvoicePeriod"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import filterUrlSync from '@/mixins/filterUrlSync';
  import { isNonEmptyArr } from '@/utils';

  export default {
    mixins: [filterUrlSync],
    components: {
      FiltersForm,
    },
    props: {
      isSkeletonLoading: {
        type: Boolean,
        default: false
      }
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
          { field: 'issueDate', urlKey: 'issue_date', type: 'string' },
          { field: 'invoicePeriod', urlKey: 'invoice_period', type: 'string' },
          { field: 'selectedCountries', urlKey: 'countries', type: 'string[]' },
        ],
        issueDate: '',
        invoicePeriod: '',
        selectedCountries: [],
        dateConfig: {
          mode: 'range',
        },
        search: '',
      };
    },
    computed: {
      hasFilters() {
        const {
          search,
          issueDate,
          invoicePeriod,
          selectedCountries
        } = this;
        return search !== '' ||
          issueDate !== '' ||
          invoicePeriod !== '' ||
          isNonEmptyArr(selectedCountries);
      },
    },
    methods: {
      onChangeIssueDate(dates) {
        this.issueDate = dates;
      },
      onChangeInvoicePeriod(dates) {
        this.invoicePeriod = dates;
      },
      onFilter() {
        const { search, issueDate, invoicePeriod, selectedCountries } = this;

        this.syncFiltersToUrl();

        this.$emit('filter', {
          search,
          issueDate,
          invoicePeriod,
          countries: selectedCountries
        });
      },
      onClearFilters() {
        this.search = '';
        this.issueDate = '';
        this.invoicePeriod = '';
        this.selectedCountries = [];

        this.clearFiltersUrl();

        const { search, issueDate, invoicePeriod, selectedCountries } = this;
        this.$emit('clearFilters', {
          search,
          issueDate,
          invoicePeriod,
          countries: selectedCountries
        });
      },
    },
  };
</script>

<style lang="scss">

</style>
